import { useEffect, useState } from "react"
import Reviews from "./reviews";
import Requests, { IRequest } from "./requests";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase";
import AdminPage from "../../../core/admin/adminPage";
import AdminCard from "../../../core/admin/adminCard";
import AdminTabs from "../../../core/admin/adminTabs";

export default function AdminReviews() {

    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState("");
    const [requests, setRequests] = useState<IRequest[] | null>(null);

    useEffect(() => {
        getRequests();
        // eslint-disable-next-line
    }, []);

    const getRequests = async () => {
        try {
            setLoading(true);
            setFeedback("");
            let docs: IRequest[] = [];
            const q = collection(db, "reviewsrequests");
            const docsSnap = await getDocs(q);
            if (docsSnap.empty) {
                setLoading(false);
                setFeedback("Nenhum resultado encontrado");
                setRequests(null);
                return null;
            }
            docsSnap.forEach(document => {
                docs.push({
                    id: document.id,
                    advertiser: document.data().advertiser,
                    review: document.data().review,
                    reason: document.data().reason,
                    createdAt: document.data().createdAt?.toDate(),
                    solved: document.data().solved,
                })
            })

            setRequests(docs);
            setLoading(false);
            return null;
        } catch (error) {
            console.log(error);
            setFeedback("Erro na busca!");
            setLoading(false);
            return null;
        }
    }

    const openRequests = requests?.filter(req => !req.solved).length || 0;

    return (
        <AdminPage title="Avaliações" description="Busque e modere avaliações de anunciantes e analise os pedidos de exclusão enviados por eles.">
            <AdminCard
                bodyClassName="p-4 md:p-6"
                header={
                    <AdminTabs
                        value={tab}
                        onChange={setTab}
                        tabs={[
                            { value: 0, label: "Avaliações" },
                            { value: 1, label: "Solicitações", count: openRequests || undefined, alert: openRequests > 0 },
                        ]}
                    />
                }
            >
                {
                    tab === 0 ?
                    <Reviews requests={requests}/>
                    : tab === 1 ?
                    <Requests feedback={feedback} loading={loading} requests={requests} refresh={getRequests}/>
                    : null
                }
            </AdminCard>
        </AdminPage>
    )
}
